import { Box } from '@mui/material';
import { useEffect } from 'react';

import useResponsive from '@/components/hooks/useResponsive';
import HeroContent from '@/components/pages/visitorHome/GreaterCareLayout/Hero/HeroContent';
import HeroZipPanel from '@/components/pages/visitorHome/GreaterCareLayout/Hero/HeroZipPanel';

import heroImage from '@/../public/rebranding/hero-large.webp';
import heroImageMobile from '@/../public/rebranding/hero-mobile.webp';

const preloadImage = (url: string) => {
  const img = new Image();
  img.src = url;
};

function Hero() {
  const { isMobile } = useResponsive();

  useEffect(() => {
    if (isMobile) {
      preloadImage(heroImageMobile.src);
    } else {
      preloadImage(heroImage.src);
    }
  }, [isMobile]);

  return (
    <Box width="100%">
      <Box
        sx={(theme) => ({
          padding: {
            xs: theme.spacing(2, 3),
            sm: theme.spacing(5, 0, 0, 4),
            lg: theme.spacing(5, 0, 0, 0),
          },
          height: {
            xs: '560px',
            sm: '580px',
            md: '564px',
          },
          backgroundImage: {
            xs: `url(${heroImageMobile.src})`,
            sm: `url(${heroImage.src})`,
          },
          backgroundPosition: {
            xs: 'center',
            sm: '60%',
            md: 'center',
          },

          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          overflow: 'hidden',
        })}>
        <Box
          sx={{
            maxWidth: {
              xs: '100%',
              sm: '1280px',
            },
            margin: '0 auto',
          }}>
          <HeroContent />
          <HeroZipPanel />
        </Box>
      </Box>
    </Box>
  );
}

export default Hero;
